import { Badge } from '@frontend/legacy-components';

import {
  COST_CATEGORY,
  COST_CATEGORY_COLOR,
  COST_CATEGORY_LABEL,
} from 'constants/all';

const CostCategoryBadge = ({ category, ...rest }) => {
  const uiCategory = COST_CATEGORY[category];
  const color = COST_CATEGORY_COLOR[uiCategory];

  if (!color) {
    return null;
  }

  return (
    <Badge bgColor={color} borderColor={color} {...rest}>
      {COST_CATEGORY_LABEL[uiCategory]}
    </Badge>
  );
};

export default CostCategoryBadge;
